import React from 'react';
import { Helmet } from 'react-helmet-async';

// Schema markup component for the dietitian as a person
const PersonSchema = () => {
  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Nihal Kamış",
    "jobTitle": "Diyetisyen",
    "worksFor": {
      "@type": "Organization",
      "name": "Diyetisyen Nihal Kamış"
    },
    "image": "https://www.nihalkamis.com/assets/placeholder-dietitian.png",
    "email": "mailto:info@nihalkamis.com",
    "telephone": "+90-XXX-XXX-XX-XX", // Placeholder - add actual phone
    "description": "İstanbul Medipol Üniversitesi Beslenme ve Diyetetik Bölümü'nden dereceyle mezun olan diyetisyen Nihal Kamış, kişiye özgü diyet planları ve beslenme danışmanlığı sunmaktadır.",
    "alumniOf": {
      "@type": "CollegeOrUniversity",
      "name": "İstanbul Medipol Üniversitesi"
    },
    "knowsAbout": [
      "Beslenme Danışmanlığı",
      "Diyet Planlama",
      "Kilo Yönetimi",
      "Sporcu Beslenmesi",
      "Hastalıklarda Beslenme",
      "Gebe ve Anne-Çocuk Beslenmesi",
      "Bariyatrik Cerrahi Diyetisyenliği",
      "Obezite Yönetimi"
    ],
    "hasCredential": {
      "@type": "EducationalOccupationalCredential",
      "credentialCategory": "Dietitian",
      "educationalLevel": "Bachelor's Degree",
      "recognizedBy": {
        "@type": "EducationalOrganization",
        "name": "T.C. Sağlık Bakanlığı"
      }
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "İstanbul",
      "addressCountry": "TR"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "İstanbul"
      }
    ],
    "sameAs": [
      "https://www.instagram.com/nihalkamis",
      "https://www.facebook.com/nihalkamis"
    ],
    "award": [
      "Dereceyle mezuniyet - İstanbul Medipol Üniversitesi"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(personSchema)}
      </script>
    </Helmet>
  );
};

export default PersonSchema;